import styled from 'styled-components';
import color from '../../../constants/color';
import materialUI from '../../../material-UI';

export const Margin = styled.div`
  margin-left: 190px;
  margin-right: 190px;
`;
export const Row: any = styled.div`
  display: flex;
  flex-direction: row;
  margin: 32px 32px 0px 32px;
  align-items: center;
  justify-content: center;
`;
export const InputBox = styled.div`
  display: flex;
  width: 100%;
`;
export const Space = styled.div`
  width: 32px;
  height: 22px;
`;
export const MarginInput: any = styled.div`
  margin: 32px 32px 32px 32px;
`;
export const MarginText = styled.div`
  margin: 0px 32px 8px 32px;
`;
export const Title = styled.div`
  font-family: Inter;
  font-size: 14px;
`;
export const Divider = styled(materialUI.Divider)`
  margin: 0px 32px 32px 32px;
`;
export const Img: any = styled.img`
  background-color: ${(props: any) => props.style?.backgroundColor};
`;
export const Info = styled.div`
  font-size: 14px;
  color: ${color.Black};
  margin: 0px 8px 0px 8px;
  font-family: Inter;
  text-align: center;

  @media only screen and (max-width: 1200px) {
    margin: 8px 8px 8px 8px;
  }
`;

export const RowFotter = styled.div`
  display: flex;
  flex-direction: row;
  margin: 32px 32px 0px 0px;
  align-items: center;
  justify-content: space-between;
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;
export const ContainerIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  cursor: pointer;
  background-color: #FBC9C9;
  border-radius: 30px;
`;
export const ContainerPlus = styled.div`
  display: flex;
  margin-left: 32px;
`;
export const OnPress = styled(materialUI.IconButton)``;
